'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'industry-windows';
var width = 512;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M160 80l0 96c66.7-30.3 173.3-78.8 176-80l0 80c66.7-30.3 173.3-78.8 176-80l0 384-512 0 0-448 160 0 0 48zm19.9 139.7l-67.9 30.8 0-170.5-64 0 0 352 416 0 0-261.5c-78.8 35.8-137.5 62.5-176 80l0-80-108.1 49.2zM160 320l0 64-64 0 0-64 64 0zm128 0l0 64-64 0 0-64 64 0zm64 64l0-64 64 0 0 64-64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;